import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
    mc: -1,
    countMc: -1,
    requestReasons: -1,
  },
  details: {},
  mc: [],
  requestReasons: [],
  countMc: 0,
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.PATIENT_GET_REQUESTED:
      return {
        ...state,
        status: {
          loading: 0,
        },
      };
    case ACTION_TYPES.PATIENT_GET_SUCCEED:
      return {
        ...state,
        status: {
          loading: 1,
        },
        details: payload,
      };
    case ACTION_TYPES.PATIENT_GET_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error,
      };

    case ACTION_TYPES.APPOINTMENT_PATIENT_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          createPatient: 0,
        },
        createdPatient: null,
      };
    case ACTION_TYPES.APPOINTMENT_PATIENT_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          createPatient: 1,
        },
        createdPatient: payload.data,
      };
    case ACTION_TYPES.APPOINTMENT_PATIENT_CREATE_FAILED:
      return {
        ...state,
        status: {
          createPatient: 2,
        },
        createdPatient: null,
        error,
      };

    case ACTION_TYPES.PATIENT_GET_LAST_30_DAYS_MC_REQUESTED:
      return {
        ...state,
        status: {
          mc: 0,
        },
        mc: [],
      };
    case ACTION_TYPES.PATIENT_GET_LAST_30_DAYS_MC_SUCCEED:
      return {
        ...state,
        status: {
          mc: 1,
        },
        mc: payload.data,
      };
    case ACTION_TYPES.PATIENT_GET_LAST_30_DAYS_MC_FAILED:
      return {
        ...state,
        status: {
          mc: 2,
        },
        mc: [],
        error,
      };

    case ACTION_TYPES.PATIENT_COUNT_LAST_30_DAYS_MC_REQUESTED:
      return {
        ...state,
        status: {
          countMc: 0,
        },
        countMc: 0,
      };
    case ACTION_TYPES.PATIENT_COUNT_LAST_30_DAYS_MC_SUCCEED:
      return {
        ...state,
        status: {
          countMc: 1,
        },
        countMc: payload.data.total,
      };
    case ACTION_TYPES.PATIENT_COUNT_LAST_30_DAYS_MC_FAILED:
      return {
        ...state,
        status: {
          countMc: 2,
        },
        countMc: 0,
        error,
      };

    case ACTION_TYPES.PATIENT_COUNT_LAST_30_DAYS_MC_RESET:
      return {
        ...state,
        status: {
          countMc: 1,
        },
        countMc: 0,
        error,
      };

    case ACTION_TYPES.PATIENT_GET_RECENT_REASON_REQUESTED:
      return {
        ...state,
        status: {
          requestReasons: 0,
        },
        requestReasons: [],
      };
    case ACTION_TYPES.PATIENT_GET_RECENT_REASON_SUCCEED:
      return {
        ...state,
        status: {
          requestReasons: 1,
        },
        requestReasons: payload.data,
      };
    case ACTION_TYPES.PATIENT_GET_RECENT_REASON_FAILED:
      return {
        ...state,
        status: {
          requestReasons: 2,
        },
        requestReasons: [],
        error,
      };
    case ACTION_TYPES.PATIENT_GET_RECENT_REASON_RESET:
      return {
        ...state,
        status: {
          requestReasons: -1,
        },
        requestReasons: [],
        error,
      };

    default:
      return state;
  }
}
